import { IconMenu, IconX } from "@tabler/icons-react";
import type { ReactElement } from "react";
import { Button } from "../Button";
import { ThemeToggleButton } from "../ThemeToggleButton";
import styles from "./MarketingTopNav.module.css";

export interface NavMenuControlClusterProps {
  menuOpen: boolean;
  onMenuToggle: () => void;
  menuClosedLabel?: string;
  menuOpenLabel?: string;
}

/**
 * Compact nav menu trigger — hamburger swaps to close (X) while open; theme
 * toggle slides out 16px to the left (same motion as marketing compact nav).
 */
export function NavMenuControlCluster({
  menuOpen,
  onMenuToggle,
  menuClosedLabel = "Open menu",
  menuOpenLabel = "Close menu"
}: NavMenuControlClusterProps): ReactElement {
  return (
    <div className={styles.menuControlCluster}>
      <div
        className={[styles.themeReveal, menuOpen ? styles.themeRevealOpen : ""]
          .filter(Boolean)
          .join(" ")}
        aria-hidden={!menuOpen}
      >
        <ThemeToggleButton />
      </div>
      <Button
        className={styles.menuToggle}
        variant="outline"
        icon={menuOpen ? IconX : IconMenu}
        aria-label={menuOpen ? menuOpenLabel : menuClosedLabel}
        aria-haspopup="dialog"
        aria-expanded={menuOpen}
        onClick={onMenuToggle}
      />
    </div>
  );
}
